document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768) {
    //waitForAppOptions();
  }
});



function waitForAppOptions() {
    
    const PARENT_ID = 'shopify-block-AMmRFaFdBdlpvZk5BM__easify_options_easify_product_options_LJ9RRm';
    const CHILD_CLASS = '.tpo_option-set-container';
    const TIMEOUT_MS = 2000;
    
    const parentBlock = document.getElementById(PARENT_ID);

    if (!parentBlock) {
        return; 
    }

    let observer;
    let timeoutId;

    const callback = (mutationsList, obs) => {
        const childElement = parentBlock.querySelector(CHILD_CLASS);
        
        if (childElement) {
            obs.disconnect();
            clearTimeout(timeoutId);


            const variantPickerElement = document.querySelector('.product-information .variant-picker');
            if (variantPickerElement) {
              variantPickerElement.style.display = 'flex';
            }
            
            const formButtonsElement = document.querySelector('.product-information .product-form-buttons');
            if (formButtonsElement) {
              formButtonsElement.style.display = 'flex';
            }

            const buttonWl = document.querySelector('.ooo-wl-button-container');
            if (buttonWl) {
              buttonWl.style.marginTop = 0;
            }

        }
    };

    const config = { 
        childList: true, 
        subtree: true    
    };

    timeoutId = setTimeout(() => {
        if (parentBlock.querySelector(CHILD_CLASS) === null) {
            observer.disconnect();
            createMobileStickyElements(); 
        }
    }, TIMEOUT_MS);

    observer = new MutationObserver(callback);
    observer.observe(parentBlock, config);
}


function createMobileStickyElements() {
  const productForm = document.querySelector('.shopify-product-form');
  if (!productForm) {
    console.log('No se encontró el formulario del producto');
    return;
  }

  // Botón añade a la cesta
  const stickyButton = document.createElement('button');
  stickyButton.className = 'mobile-sticky-button';
  stickyButton.textContent = 'Añadir a la cesta';
  stickyButton.type = 'button';
  

  const updateStickyText = () => {
    
    const currentOriginalButton = productForm.querySelector('.add-to-cart-button'); 
    if (!currentOriginalButton) return;
    
    // Verificamos el estado disabled
    const isAvailable = currentOriginalButton.disabled !== true; 
  
    if (!isAvailable) {
        stickyButton.disabled = true; 
        stickyButton.classList.add('button_float_disabled');
        stickyButton.textContent = 'Agotado'; // Forzamos este texto
        console.log('AGOTADO');
    } else {
        //stickyButton.disabled = false;
        //stickyButton.classList.remove('unavailable');
        //stickyButton.textContent = 'Añadir a la cesta'; // Forzamos este texto
        console.log('AÑADIR A LA CESTA');
    }
  };
  
  const variantPicker = document.querySelector('variant-picker');
  const originalButton = productForm.querySelector('.add-to-cart-button');
  
  if (!originalButton) {
    console.log('No se encontró el botón de añadir al carrito');
    return;
  }


  // creo contenedor flotante
  const stickyContainer = document.createElement('div');
  stickyContainer.className = 'mobile-sticky-container';
  
  const stickyContent = document.createElement('div');
  stickyContent.className = 'mobile-sticky-content';
  
  if (variantPicker) {

    console.log('Variant picker encontrado:');

    const fieldsets = variantPicker.querySelectorAll('fieldset');
    
    fieldsets.forEach((fieldset, fieldsetIndex) => {
      const radioButtons = fieldset.querySelectorAll('input[type="radio"]');
      
      if (radioButtons.length > 0) {
        const variantWrapper = document.createElement('div');
        variantWrapper.className = 'mobile-sticky-variant-option';
        
        const label = document.createElement('div');
        label.textContent = '';
        label.className = 'mobile-sticky-variant-label';
        variantWrapper.appendChild(label);
        
        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'mobile-sticky-variant-buttons';
        
        radioButtons.forEach((radio, radioIndex) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mobile-sticky-variant-button';
          button.textContent = radio.value;
          
          if (radio.checked) {
            button.classList.add('selected');
          }
          
          if (radio.getAttribute('data-option-available') === 'false') {
            button.classList.add('disabled');
            button.disabled = true;
          }
          
          button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (!this.disabled) {
              // Desmarco otros botones
              buttonsContainer.querySelectorAll('.mobile-sticky-variant-button').forEach(btn => {
                btn.classList.remove('selected');
              });
              
              // Boton activo
              this.classList.add('selected');
              radio.checked = true;
              
              // Disparar eventos
              radio.dispatchEvent(new Event('change', { bubbles: true }));
              radio.dispatchEvent(new Event('click', { bubbles: true }));
              
            }
          });
          
          buttonsContainer.appendChild(button);
        });
        
        variantWrapper.appendChild(buttonsContainer);
        stickyContent.appendChild(variantWrapper);
      }
    });
  }
  
  
  stickyButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    originalButton.click();
  });

  updateStickyText();
  
  stickyContent.appendChild(stickyButton);
  stickyContainer.appendChild(stickyContent);
  document.body.appendChild(stickyContainer);
  

  productForm.addEventListener('change', (e) => {
    // Timeout para esperar a que el tema actualice el estado del botón original.
    setTimeout(updateStickyText, 50); 
  });

  setTimeout(function() {
    stickyContainer.classList.add('show');
  }, 100); 

}


